<button
  *ngFor="let item of pages"
  [class]="item.type"
  [class.disabled]="isInactive(item)"
  [class.current]="isCurrent(item)"
  [tabIndex]="isInactive(item) ? -1 : 0"
  (click)="pageChange(item)"
  [attr.aria-label]="getAriaLabel$(item) | async"
>
  {{ item.label }}
</button>
